
import { useState } from 'react';

interface ShareContent {
  title: string;
  content: string;
  url?: string;
  shareText?: string;
}

export function useShareDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const [shareContent, setShareContent] = useState<ShareContent>({
    title: '',
    content: '',
  });

  const openShareDialog = (content: ShareContent) => {
    setShareContent(content);
    setIsOpen(true);
  };

  const closeShareDialog = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    shareContent,
    openShareDialog,
    closeShareDialog,
  };
}
